// src/helper/validateName.js

export const validateName = (name) => {
    if (typeof name !== 'string') return false;

    const trimmedName = name.trim();

    // Length check
    if (trimmedName.length < 1 || trimmedName.length > 50) return false;

    // XSS prevention – disallow HTML tags
    const xssRegex = /<[^>]*>/;
    if (xssRegex.test(trimmedName)) return false;

    // Unicode-safe name validation:
    // Allows letters, accents, spaces, apostrophes, dashes, dots
    const nameRegex = /^[\p{L}\p{M}\s.'’-]+$/u;
    return nameRegex.test(trimmedName);
};
